/* eslint-disable no-console */
import { Injectable, isDevMode } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApLoggingService {
    public get debug(): any {
        return this.isEnabled() ? console.debug.bind(console) : this.noOp;
    }

    public get error(): any {
        return this.isEnabled() ? console.error.bind(console) : this.noOp;
    }

    public get log(): any {
        return this.isEnabled() ? console.log.bind(console) : this.noOp;
    }

    public get info(): any {
        return this.isEnabled() ? console.info.bind(console) : this.noOp;
    }

    public get warn(): any {
        return this.isEnabled() ? console.warn.bind(console) : this.noOp;
    }

    private noOp(): void {}

    private isEnabled(): boolean {
        return isDevMode();
    }
}
